// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import HomePage from "./pages/Homepage";
import Request from "./pages/Request";
import Login from "./pages/Login";
import CheckLicense from "./pages/Checklicense";
import RequireAuth from "./pages/RequireAuth";
import Datasheet from "./pages/Datasheet";
import Terms from "./pages/Terms";
import List from "./pages/LicenseList";
import View from "./pages/ViewDetail";
import Change from "./pages/ChangePassword";
import Forgot from "./pages/Forgot";
import Profile from "./pages/Profile";
import NotFound from "./components/NotFound";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/request" element={<Request />} />
        <Route path="/login" element={<Login />} />
        <Route path="/datasheet" element={<Datasheet />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/forgot" element={<Forgot />} />

        <Route
          path="/list"
          element={
            <RequireAuth>
              <List />
            </RequireAuth>
          }
        />
        <Route
          path="/view"
          element={
            <RequireAuth>
              <View />
            </RequireAuth>
          }
        />
        <Route
          path="/change-password"
          element={
            <RequireAuth>
              <Change />
            </RequireAuth>
          }
        />
        <Route
          path="/profile"
          element={
            <RequireAuth>
              <Profile />
            </RequireAuth>
          }
        />
        <Route
          path="/check"
          element={
            <RequireAuth>
              <CheckLicense />
            </RequireAuth>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}
